import Vue from 'vue';

Vue.component('modal', require('./Modal/Modal').default);
Vue.component('app-delete-modal', require('./Modal/DeleteModal').default);
Vue.component('app-form1', require('../Views/Forms/form1.vue').default);
Vue.component('app-form2', require('../Views/Forms/form2.vue').default);
Vue.component('app-form3', require('../Views/Forms/form3.vue').default);
Vue.component('app-form4', require('../Views/Forms/form4.vue').default);
Vue.component('app-form5', require('../Views/Forms/form5.vue').default);
Vue.component('app-form6', require('../Views/Forms/form6.vue').default);
Vue.component('app-form7', require('../Views/Forms/form7.vue').default);
Vue.component('app-dashboardsign', require('../Views/Document/Dashboard.vue').default);
